import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalTitle: {
		id: 'tmp-feature-toggle.disable-prerequisite-modal.modal-title',
		defaultMessage: '{beneficiaryTitlesAsString} requires {prerequisite}',
		description: 'title for disable prerequisite modal',
	},
	modalDescription: {
		id: 'tmp-feature-toggle.disable-prerequisite-modal.modal-description',
		defaultMessage:
			"If you disable {prerequisite}, you'll automatically switch off {beneficiaryTitlesAsString} too. Are you sure you want to disable both?",
		description: 'description for disable prerequisite modal',
	},
	confirmButton: {
		id: 'tmp-feature-toggle.disable-prerequisite-modal.confirm-button',
		defaultMessage: 'Disable both',
		description: 'confirm button text',
	},
	cancelButton: {
		id: 'tmp-feature-toggle.disable-prerequisite-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'cancel button text',
	},
});
